/* ============================================================
   Judge.me Widget — NZG DOM Restructuring
   Erstellt: 2026-03-26

   Problem: Judge.me's JS läuft nach dem Seitenload und
   überschreibt den DOM (versteckt Reviews, fügt Popup-Button ein).
   Lösung: MutationObserver reagiert auf JEDE Änderung im Widget
   und macht unerwünschte Judge.me-Aktionen sofort rückgängig.
   ============================================================ */

(function () {
  'use strict';

  var isRunning = false;

  function applyFixes() {
    if (isRunning) return;
    isRunning = true;

    requestAnimationFrame(function () {
      // 1. Durchschnittswert bereinigen: "2.00 out of 5" → "2.00"
      document.querySelectorAll('.jdgm-rev-widg__summary-average:not([data-nzg-avg])').forEach(function (el) {
        el.setAttribute('data-nzg-avg', 'true');
        var match = el.textContent.trim().match(/^[\d.,]+/);
        if (match) el.textContent = match[0];
      });

      // 2. Datum in den Profil-Block verschieben (rechts neben/unter Autor)
      document.querySelectorAll('.jdgm-rev:not([data-nzg-ts])').forEach(function (rev) {
        rev.setAttribute('data-nzg-ts', 'true');
        var timestamp = rev.querySelector('.jdgm-rev__timestamp');
        var profile = rev.querySelector('.jdgm-row-profile');
        if (timestamp && profile) profile.appendChild(timestamp);
      });

      // 3. "Read More Reviews" Button (class: jdgm-btn--dark) entfernen
      document.querySelectorAll('.jdgm-btn--dark').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });

      // 4. Other-language Reviews erzwingen: immer sichtbar, nie im Popup versteckt
      document.querySelectorAll('.jdgm-rev-widg__other-lang').forEach(function (el) {
        el.style.setProperty('display', 'block', 'important');
      });
      document.querySelectorAll('.jdgm-rev-widg__other-content').forEach(function (el) {
        el.style.setProperty('display', 'block', 'important');
      });

      // 5. Falls Judge.me die Reviews in einen Popup verschoben hat:
      //    Popup-Inhalt in den inline Container kopieren
      var popupEl = document.querySelector('[id^="jdgm-widget__popup-primary-content"]');
      var inlineReviews = document.querySelector('.jdgm-rev-widg__other-content .jdgm-rev-widg__reviews');
      if (popupEl && inlineReviews) {
        var popupRevs = popupEl.querySelectorAll('.jdgm-rev:not([data-nzg-moved])');
        if (popupRevs.length > 0 && inlineReviews.querySelectorAll('.jdgm-rev').length === 0) {
          popupRevs.forEach(function (rev) {
            rev.setAttribute('data-nzg-moved', 'true');
            inlineReviews.appendChild(rev);
          });
          // Fixes erneut auf die bewegten Reviews anwenden
          applyTimestampFix();
        }
      }

      isRunning = false;
    });
  }

  // Timestamp-Fix separat (wird nach dem Verschieben erneut gebraucht)
  function applyTimestampFix() {
    document.querySelectorAll('.jdgm-rev:not([data-nzg-ts])').forEach(function (rev) {
      rev.setAttribute('data-nzg-ts', 'true');
      var timestamp = rev.querySelector('.jdgm-rev__timestamp');
      var profile = rev.querySelector('.jdgm-row-profile');
      if (timestamp && profile) profile.appendChild(timestamp);
    });
  }

  // 6. Klick-Overrides: Popup blockieren, Bilder in Lightbox öffnen.
  //    capture: true → läuft VOR Judge.me's eigenen Event-Listenern.
  function initClickOverrides() {
    document.addEventListener('click', function (e) {
      var revEl = e.target.closest('.jdgm-rev');
      if (!revEl) return;

      // Bild-Klick: nächsten <a> der ein <img> enthält finden
      var imgLink = e.target.closest('a');
      if (imgLink && imgLink.querySelector('img')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var img = imgLink.querySelector('img');
        // href bevorzugen (Vollbild-URL), sonst src des Bildes
        var src = imgLink.getAttribute('href');
        if (!src || src === '#' || src === window.location.href) {
          src = img.src || img.dataset.src;
        }
        if (src) openLightbox(src, img.alt || '');
        return;
      }

      // Alle anderen Klicks in einer Review: Popup blockieren
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  }

  // Lightbox: single global instance, lazy-created beim ersten Klick.
  var lightbox = null;
  function openLightbox(src, alt) {
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'nzg-jdgm-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.hidden = true;
      var inner = document.createElement('div');
      inner.className = 'nzg-jdgm-lightbox__inner';
      var img = document.createElement('img');
      img.className = 'nzg-jdgm-lightbox__img';
      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'nzg-jdgm-lightbox__close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.textContent = '×';
      inner.appendChild(img);
      inner.appendChild(closeBtn);
      lightbox.appendChild(inner);
      document.body.appendChild(lightbox);
      lightbox._img = img;
      function close() {
        lightbox.classList.remove('is-visible');
        setTimeout(function () { lightbox.hidden = true; }, 200);
        document.body.style.overflow = '';
      }
      lightbox.addEventListener('click', function (ev) { if (ev.target === lightbox) close(); });
      closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !lightbox.hidden) close();
      });
    }
    lightbox._img.src = src;
    lightbox._img.alt = alt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { lightbox.classList.add('is-visible'); });
  }

  function init() {
    var widget = document.querySelector('#judgeme_product_reviews') || document.body;

    // MutationObserver: reagiert auf ALLE Änderungen im Widget-Bereich
    // - childList: neue Elemente (z.B. "Read More Reviews" Button wird eingefügt)
    // - attributes + attributeFilter: style/class-Änderungen (z.B. display:none wird gesetzt)
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        if (m.type === 'childList' && m.addedNodes.length > 0) return true;
        if (m.type === 'attributes') {
          var target = m.target;
          // Reagieren wenn ein relevantes Element versteckt wird
          return (
            target.classList &&
            (
              target.classList.contains('jdgm-rev-widg__other-lang') ||
              target.classList.contains('jdgm-rev-widg__other-content') ||
              target.classList.contains('jdgm-rev-widg__reviews') ||
              target.classList.contains('jdgm-btn--dark')
            )
          );
        }
        return false;
      });

      if (relevant) applyFixes();
    });

    observer.observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    // Zeitgestaffelte Runs: Judge.me kann 50ms–3s nach dem Load kommen
    setTimeout(applyFixes, 100);
    setTimeout(applyFixes, 500);
    setTimeout(applyFixes, 1200);
    setTimeout(applyFixes, 2500);

    initClickOverrides();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
